import SectionHeader from "@/components/ui/section-header";

interface FitRow {
  requirement: string;
  fit: boolean;
  note?: string;
}

const ROWS: FitRow[] = [
  {
    requirement: "Globale Datenerfassung aus dem öffentlichen Web",
    fit: true,
    note: "Residential-Abdeckung in 195+ Ländern",
  },
  { requirement: "Land-, Stadt- oder ISP-Targeting", fit: true },
  { requirement: "Rotation bei unabhängigen Anfragen", fit: true },
  { requirement: "Sticky mehrstufige Sessions", fit: true },
  {
    requirement: "Bestehender Scraper oder Browser-Automatisierung",
    fit: true,
    note: "Standard-Proxy-Zugangsdaten lassen sich in das eigene Tool einbinden",
  },
  {
    requirement: "Verwaltetes Scraping und aufbereitete Daten",
    fit: false,
    note: "Scraper und Extraktionsschicht werden selbst betrieben",
  },
  {
    requirement: "Eine dedizierte IP dauerhaft halten",
    fit: false,
    note: "nicht der primäre Anwendungsfall dieses rotierenden Residential-Produkts",
  },
  { requirement: "Kostenloser Residential-Proxy-Datenverkehr", fit: false },
];

export default function ResidentialFitCheckDe() {
  return (
    <section
      className="py-section-sm border-border border-b"
      aria-labelledby="residential-fit-check-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="Passt das zu Ihnen?"
            id="residential-fit-check-heading"
            heading="Für wen Residential Proxies geeignet sind"
            body="Die eigene Anforderung mit dem abgleichen, was dieses Produkt tatsächlich leistet, bevor es gekauft wird."
          />
        </div>

        <div className="border-border bg-card mt-8 overflow-x-auto rounded-2xl border">
          <table className="w-full border-collapse text-left text-sm">
            <thead>
              <tr className="border-border border-b">
                <th className="text-foreground px-5 py-3 font-semibold sm:px-6">Anforderung</th>
                <th className="text-foreground px-5 py-3 font-semibold sm:px-6">
                  Passt Proxidize?
                </th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.requirement} className="border-border/60 border-b last:border-b-0">
                  <td className="text-muted-foreground px-5 py-3 leading-relaxed sm:px-6">
                    {row.requirement}
                  </td>
                  <td className="px-5 py-3 leading-relaxed sm:px-6">
                    <span
                      className={
                        row.fit
                          ? "text-brand-green font-semibold"
                          : "text-muted-foreground font-semibold"
                      }
                    >
                      {row.fit ? "Ja" : "Nein"}
                    </span>
                    {row.note && <span className="text-muted-foreground"> — {row.note}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
